export const APP_GET_INIT = 'app/APP_GET_INIT'
export const APP_INIT_STATE = 'app/APP_INIT_STATE'
export const APP_SHOW_SIGN_UP = 'app/APP_SHOW_SIGN_UP'
export const APP_SIGN_UP_REQUEST = 'app/APP_SIGN_UP_REQUEST'
export const APP_SIGN_UP_SUCCESS = 'app/APP_SIGN_UP_SUCCESS'
export const APP_SIGN_UP_FAILURE = 'app/APP_SIGN_UP_FAILURE'
export const APP_SET_IN_LOAD = 'app/APP_SET_IN_LOAD'
export const APP_SET_ALERT_MESSAGE = 'app/APP_SET_ALERT_MESSAGE'
export const APP_DISPLAY_UNKNOWN_ERROR = 'app/APP_DISPLAY_UNKNOWN_ERROR'
